<template>
  <v-badge
    bordered
    :color="notificationsLength ? 'green' : 'grey-lighten-2'"
    :content="notificationsLength > 100 ? '100+' : notificationsLength"
    :model-value="notificationsLength > 0"
    location="top end"
  >
    <slot />
  </v-badge>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'NotificationBadge',

  props: {
    notificationsLength: {
      type: Number,
      default: 0
    }
  }
})
</script>
